import type { ISxProps } from './types'
import { Box, Typography } from '@/CommonComponents'
import { Radio as MUIRadio } from '@mui/material'
interface IRadioButtonProps {
  label: string
  value: string
  caption?: string
  checked: boolean
  onChange: () => void
  sx?: ISxProps
}
export default function RadioButton({ label, value, checked, onChange, sx, caption }: IRadioButtonProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ...sx }}>
      <MUIRadio id={value} value={value} checked={checked} onChange={onChange} />
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="body1">{label}</Typography>
        {caption && <Typography variant="caption">{caption}</Typography>}
      </Box>
    </Box>
  )
}
